/** Build-time CRA env (REACT_APP_*). Values are embedded at `npm run build`. */

export const env = {
  companyName: (process.env.REACT_APP_COMPANY_NAME || "Converse AI").trim(),
  primaryColor: (process.env.REACT_APP_PRIMARY_COLOR || "").trim(),
  showDemoCredentials: process.env.REACT_APP_SHOW_DEMO_CREDENTIALS === "true",
  whisperWsUrl: (process.env.REACT_APP_WHISPER_WS_URL || "").trim(),
  whisperModel: (process.env.REACT_APP_WHISPER_MODEL || "small.en").trim(),
} as const;

export function parseBrandDisplay(name: string): { head: string; accent: string } {
  const trimmed = name.trim();
  if (trimmed.endsWith(".AI")) {
    return { head: trimmed.slice(0, -3), accent: ".AI" };
  }
  if (trimmed.endsWith(" AI")) {
    return { head: trimmed.slice(0, -3), accent: ".AI" };
  }
  return { head: trimmed, accent: "" };
}
